import { getClipboardText } from '../../../../../../utils/clipboard'
import { getRecipientItemId } from '../../../EmailRecipientsField.utils'

export function deselectRecipient(value, selectedKey) {
  return value.filter(i => getRecipientItemId(i) !== selectedKey)
}

export function getInputValueWithPastedText(event) {
  const { selectionEnd, selectionStart, value } = event.target

  return (
    value.slice(0, selectionStart) +
    getClipboardText(event) +
    value.slice(selectionEnd)
  )
}

export function isSelectedRecipient(value, selectedKey) {
  return value.some(i => getRecipientItemId(i) === selectedKey)
}

export function selectRecipient(
  value,
  selected,
  onExpandSelectedRecipientEmails
) {
  const baseItems = [...value.filter(i => !!i.value), selected]
  const additions =
    onExpandSelectedRecipientEmails?.(baseItems, selected) ?? null

  return additions?.length > 0 ? [...baseItems, ...additions] : baseItems
}
